import { defineStore } from 'pinia'
import { isArray } from 'lodash'

import { api, mock } from '@/services'
import { useAppStore } from '@/stores/app'

export const useMoreStore = defineStore('more', {
    state: () => {
        return {
            loaded: false,
            more: [],
        }
    },
    actions: {
        // Loading of the more module content
        async load() {
            const { appId } = useAppStore()
            // If mocking use the mock content
            if (mock.mockingMore()) {
                const content = mock.content()
                // TODO: Remove once we are sure the mock content is always an array
                this.more = isArray(content) || isNil(content) ? content : [content]
                return
            }
            await api.get(`/${appId}/more`)
                .then(({ data }) => {
                    // TODO: Remove once we are sure the API always returns an array
                    this.more = isArray(data) || isNil(data) ? data : [data]
                    this.loaded = true
                })
        },
    },
})
